import { Button, Modal, TextField, FormLayout, Form, Select, Checkbox } from '@shopify/polaris';
import { useState, useCallback } from 'react';
import { currenciesJSON } from '../../../helpers/currenciesList';
import { DEPOSIT_TYPE_OPTIONS } from '../../../helpers/depositTypes';

export const NewDepositModal = ({ onAddDeposit, disable }) => {
  const [active, setActive] = useState(false);
  const [isOnlyGroup, setIsOnlyGroup] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);

  const defaultData = {
    name: '',
    code: '',
    currency: 'MXN',
    depositType: 'store',
  };
  const [dataForm, setDataForm] = useState(defaultData);

  const activator = (
    <Button onClick={handleChange} disabled={disable}>
      Nuevo deposito
    </Button>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = isOnlyGroup
      ? { name: dataForm.name, code: dataForm.code, isOnlyGroup: true }
      : dataForm;
    try {
      await onAddDeposit(payload);
      setDataForm(defaultData);
      setIsOnlyGroup(false);
      setActive(false);
    } catch (e) {}
  };

  return (
    <>
      {activator}

      {active && (
        <Modal
          open={active}
          onClose={handleChange}
          title="Crear nuevo depósito"
          primaryAction={{
            content: 'Crear',
            onAction: handleSubmit,
          }}
        >
          <Modal.Section>
            <Form onSubmit={handleSubmit}>
              <FormLayout>
                <Checkbox
                  label="Es un grupo (sin stock propio)"
                  checked={isOnlyGroup}
                  onChange={setIsOnlyGroup}
                />
                <TextField
                  label="Nombre"
                  type="name"
                  value={dataForm.name}
                  autoComplete="off"
                  onChange={(e) => setDataForm({ ...dataForm, name: e })}
                />
                <TextField
                  label="Código"
                  type="name"
                  value={dataForm.code}
                  autoComplete="off"
                  onChange={(e) => setDataForm({ ...dataForm, code: e })}
                />
                {!isOnlyGroup && (
                  <Select
                    label="Moneda"
                    options={currenciesJSON.map((e) => ({ label: `(${e.code}) ${e.name}`, value: e.code }))}
                    onChange={(e) => setDataForm({ ...dataForm, currency: e })}
                    value={dataForm.currency}
                  />
                )}
                {!isOnlyGroup && (
                  <Select
                    label="Rol (informes)"
                    helpText="Tienda, outlet, córner, pop-up y venta remota forman el perímetro de venta de los informes. El resto queda fuera."
                    options={DEPOSIT_TYPE_OPTIONS}
                    onChange={(e) => setDataForm({ ...dataForm, depositType: e })}
                    value={dataForm.depositType}
                  />
                )}
              </FormLayout>
            </Form>
          </Modal.Section>
        </Modal>
      )}
    </>
  );
};
